import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";

export {
  tasksAllFieldsList,
  tasksDefaultConfiguration,
  tasksLegacyColumnIdMap,
  normalizeVisibleTOPColumns,
  getTasksColumnCellValue,
  TASKS_TABLE_COLUMN_DATA_KEY,
} from "@/src/constants/tasksTableColumns";
export type { TasksColumnConfig } from "@/src/constants/tasksTableColumns";

export const tasksHeaderSelectConst = [
  {
    id: "ALL",
    title: "All",
    mass: [{ name: "All Tasks" }, { name: "New" }, { name: "In Progress" }, { name: "Under Review" }, { name: "Completed" }],
  },
  {
    id: "UKRAINE",
    title: "Ukraine",
    mass: [{ name: "All Tasks" }, { name: "New" }, { name: "In Progress" }, { name: "Under Review" }, { name: "Completed" }],
  },
  {
    id: "MALTA",
    title: "Malta",
    mass: [{ name: "All Tasks" }, { name: "New" }, { name: "In Progress" }, { name: "Under Review" }, { name: "Completed" }],
  },
  {
    id: "POLAND",
    title: "Poland",
    mass: [{ name: "All Tasks" }, { name: "New" }, { name: "In Progress" }, { name: "Under Review" }, { name: "Completed" }],
  },
];

export const tasksFilterStatusesConst = [
  { label: "All", value: "All", statusId: null },
  { label: "New", value: "New", statusId: "new" },
  { label: "In Process", value: "In Process", statusId: "in_process" },
  { label: "Document Check", value: "Document Check", statusId: "document_check" },
  { label: "Done", value: "Done", statusId: "done" },
  { label: "Rejected", value: "Rejected", statusId: "rejected" },
] as const;

export const tasksStarsConst = [
  { color: "default", Icon: applicationPageSvgConst.StarDefaultSvg, description: "default" },
  { color: "black", Icon: applicationPageSvgConst.StarBlackSvg, description: "black" },
  { color: "yellow", Icon: applicationPageSvgConst.StarYellowSvg, description: "yellow" },
  { color: "red", Icon: applicationPageSvgConst.StarRedSvg, description: "red" },
  { color: "green", Icon: applicationPageSvgConst.StarGreenSvg, description: "green" },
  { color: "headBoom", Icon: applicationPageSvgConst.HeadBoomSvg, description: "headBoom" },
  { color: "fingers", Icon: applicationPageSvgConst.FingersSvg, description: "fingers" },
  { color: "money", Icon: applicationPageSvgConst.MoneySvg, description: "money" },
  { color: "stop", Icon: applicationPageSvgConst.StopSvg, description: "stop" },
  { color: "sos", Icon: applicationPageSvgConst.SosSvg, description: "sos" },
];

export const tasksStatusConst = [
  { label: "New", id: "new" },
  { label: "In Process", id: "in_process" },
  { label: "Document Check", id: "document_check" },
  { label: "Done", id: "done" },
  { label: "Rejected", id: "rejected" },
];

export const tasksActionsConst = [
  { name: "preview", icon: applicationPageSvgConst.PreviewSvg },
  { name: "documentCheckActions", icon: applicationPageSvgConst.TasksSvg },
  { name: "comments", icon: applicationPageSvgConst.CommentsSvg },
  { name: "download", icon: applicationPageSvgConst.DownloadSvg },
  { name: "unread", icon: applicationPageSvgConst.UnreadSvg },
  { name: "admissionForward", icon: applicationPageSvgConst.AdmissionForwardSvg },
  { name: "tasks", icon: applicationPageSvgConst.TasksSvg },
  { name: "move", icon: applicationPageSvgConst.DocumentPreparationSvg },
  { name: "delete", icon: applicationPageSvgConst.DeleteSvg },
];
